import EdittorQuestion from '../models/Question'
import OriginalQuestion from '../../api/v2/models/question'
import { Range as AceRange } from 'brace'
import Skill from '../models/Skill'
import ErrorRange from '../lib/ErrorRange'
import { ISchool, IExam } from '../../../types'
import Comparison from '../lib/comparison';
import ExamRevision from '../../api/v2/models/exam_revision';

export enum EDITOR_MODE {
  EDITOR,
  REVISION
}

export interface EditorState {
  school: ISchool
  exam: IExam
  qs: OriginalQuestion[]
  body: string
  row: number
  column: number
  range: AceRange
  currentPage: number
  questions: EdittorQuestion[]
  loaded: boolean
  skills: Skill[]
  saveMessage: string
  hasError: boolean
  errorLines: ErrorRange[]
  currentLine: string
  previousLine: string
  showSidebarMenu: string
  breadcrumbs: string[][]
  comparison: Comparison | null
  editorMode: EDITOR_MODE
  examRevisions: ExamRevision[]
  currentExamRevision: ExamRevision | null
  latestBody: string
}
